import { onUnmounted } from 'vue';
import { usePwaChatStore } from '../stores/chat';

let consumers = 0;

/**
 * Composable fino sobre `usePwaChatStore` — ponto único que o sheet contextual
 * do pedido (ChatSheet.vue) e a thread usam, sem duplicar o setup de tempo real.
 * `subscribeRealtime()` só roda uma vez mesmo com dois montados ao mesmo tempo
 * (contador de referência).
 *
 * NÃO chama `fetchConversation()` aqui (D-CHAT-18 wart#1): abrir a thread não pode
 * CRIAR uma conversa vazia — a criação acontece só no 1º envio. Cada tela decide
 * o que carregar (ativa via `fetchConversation`, novo via draft, encerrado via
 * `fetchEpisode`).
 */
export function useChat() {
    const store = usePwaChatStore();

    if (consumers === 0) {
        store.subscribeRealtime();
    }
    consumers += 1;

    onUnmounted(() => {
        consumers -= 1;
        if (consumers <= 0) {
            consumers = 0;
            store.unsubscribe();
        }
    });

    return store;
}
